<template>
  <div class="row no-gutters d-flex align-items-center">
    <div class="col-md-5">

      <!-- Author/User image -->
      <div class="simple-user-image-wrapper">
        <a :href="`/users/${user.id}/profile?category=commercio`">
          <div class="responsive-aspect-ratio square-aspect-ratio">
            <img :src="user.avatar" class="w-100 h-100 rounded-circle object-fit-cover">
          </div>
        </a>
      </div>

    </div>

    <div class="col-md-7">

      <!-- Author/User content -->
      <div class="user-content-wrapper pl-0 pl-md-4 mt-2 mt-md-0 text-center text-md-left">
        <div class="simple-user-title">
          <a class="h6 mb-0" :href="`/users/${user.id}/profile`">
            {{ user.nickname }}
          </a>
        </div>

        <div class="simple-user-info" v-if="user.display_address">
          <p class="small mb-0"><i class="fas fa-map-marker-alt"></i> {{ user.display_address }}</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "UserCard",
  props: {
    user: Object,
  }
}
</script>

<style scoped>

</style>
